import { SUBSCRIPTION_PLAN_CATEGORY } from './const';

const SUBSCRIPTION_PLAN_CATEGORY_PROPS = {
  [SUBSCRIPTION_PLAN_CATEGORY.basic]: {
    label: 'Free',
  },
  [SUBSCRIPTION_PLAN_CATEGORY.starter]: {
    label: 'Starter',
  },
  [SUBSCRIPTION_PLAN_CATEGORY.dataDriven]: {
    label: 'Data-Driven',
  },
  [SUBSCRIPTION_PLAN_CATEGORY.business]: {
    label: 'Business',
  },
  [SUBSCRIPTION_PLAN_CATEGORY.enterprise]: {
    label: 'Enterprise',
  },
  [SUBSCRIPTION_PLAN_CATEGORY.poc]: {
    label: 'POC',
  },
};

export const getPlanCategoryLabel = (category) => {
  return SUBSCRIPTION_PLAN_CATEGORY_PROPS[category]?.label || '';
};
